import SelectAutoType from './SelectAutoType';

export default SelectAutoType;